import Vue from 'vue'
import Vuex from 'vuex'

import survey from './modules/survey'
import resources from './modules/resources'
import user from './modules/user'
import groups from './modules/groups'
import customPoll from './modules/customPoll'
import customPollSurvey from './modules/customPollSurvey'
import confirmRegister from './modules/confirmRegister'
import reports from './modules/reports'
import participation from './modules/participation'
import sendInvites from './modules/sendInvites'
import confirmInvite from './modules/confirmInvite'
import tickets from './modules/tickets'
import metric from './modules/metric'
import account from './modules/account'
import licensesUpdateForm from './modules/licensesUpdateForm'
import users from './modules/users'
import password from './modules/password'
import company from './modules/company'
import recommendation from './modules/recommendation'
import notifications from './modules/notifications'
import actionPlan from './modules/actionPlan'
import integrations from './modules/integrations'
import confirmAccount from './modules/confirmAccount'
import culture from './modules/culture'
import benchmark from './modules/benchmark'
import customSurveys from './modules/customSurveys'
import customSurvey from './modules/customSurvey'
import customSurveyResults from './modules/customSurveyResults'
import comparation from './modules/comparation'
import auditLogs from './modules/auditLogs'
import userAttributes from './modules/userAttributes'

Vue.use(Vuex)

const env = window.env || process.env
const debug = env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    survey,
    resources,
    user,
    groups,
    notifications,
    customPoll,
    customPollSurvey,
    confirmRegister,
    reports,
    participation,
    sendInvites,
    confirmInvite,
    tickets,
    metric,
    users,
    password,
    recommendation,
    company,
    account,
    licensesUpdateForm,
    actionPlan,
    integrations,
    confirmAccount,
    culture,
    benchmark,
    customSurveys,
    customSurvey,
    customSurveyResults,
    comparation,
    auditLogs,
    userAttributes,
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : []
})
